import {useRouter} from 'next/router'

/**
 * Returns the hotelId from URL slug
 */
export const useHotelSlug = () => {
  const {query} = useRouter()
  return query.hotelSlug as string
}
